<template>
  <v-dialog v-model="dialog" width="600">
    <template v-slot:activator="{ on, attrs }">
      <v-tooltip bottom v-bind="attrs" v-on="on">
        <template v-slot:activator="{ on }">
          <span v-on="on">
            <v-btn x-small text @click.stop="dialog = true"
              ><v-icon small>mdi-delete</v-icon></v-btn
            >
          </span>
        </template>
        <span> Remove </span>
      </v-tooltip>
    </template>

    <v-card class="primary--text">
      <v-card-title>{{ title }}</v-card-title>
      <v-card-subtitle class="body-1 font-weight-medium">{{
        message
      }}</v-card-subtitle
      ><v-card-text>
        <label>Reason / Comments:</label>
        <v-textarea v-model="comments" auto-grow rows="2" outlined></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark text @click="dialog = false">Cancel</v-btn>
        <v-btn color="primary" dark @click="save(comments)">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["title", "message"],
  data() {
    return {
      dialog: false,
      comments: "",
    };
  },
  methods: {
    async save(event) {
      this.$emit("save", event);
      this.dialog = false;
    },
  },
};
</script>
